// A mission's candidate lists ({ complete: [...], partial: [...], … }), moved
// through state updaters: a move may land after other changes to the lists.

const byLastname = (a, b) =>
  (a.lastname?.toLowerCase() || '').localeCompare(
    b.lastname?.toLowerCase() || '',
  );

export const removeCandidateFromLists = (lists, key, idTempWorker) =>
  lists?.[key]
    ? {
        ...lists,
        [key]: lists[key].filter((data) => data.id_user !== idTempWorker),
      }
    : lists;

/** Adds the candidate in name order, unless the list already holds it. */
export const addCandidateToLists = (lists, key, candidate) => {
  const list = lists?.[key] || [];
  if (list.some((data) => data.id_user === candidate.id_user)) return lists;
  return { ...lists, [key]: [...list, candidate].sort(byLastname) };
};
